<template>
  <div>
    <modal-update-tabla
      :equipo="equipoSeleccionado"
      :listBonificaciones="listBonificaciones"
      @updateTabla="updateTabla"
    ></modal-update-tabla>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showTablaPosiciones"
      scrollable
      title="Tabla de posiciones"
      size="lg"
      hide-footer
    >
      <table class="table">
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th style="width:10px" scope="col"></th>
            <th
              scope="col"
              style="text-align: center; background-color: #e8e226; color:black"
            >
              Pts
            </th>
            <th scope="col">PJ</th>
            <th scope="col">PG</th>
            <th scope="col">PE</th>
            <th scope="col">PP</th>
            <th scope="col">NP</th>
            <th scope="col">GF</th>
            <th scope="col">GC</th>
            <th scope="col">B</th>
            <th scope="col">GD</th>
            <th scope="col">.</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in listTablaPosiciones" :key="item.id">
            <th scope="row" style="color:gray">{{ index + 1 }}</th>
            <td class="text-capitalize">{{ item.equipo }}</td>
            <td style="text-align: center; background-color: #e8e226">
              <b>{{ item.pts }}</b>
            </td>
            <td>{{ item.pj }}</td>
            <td>{{ item.pg }}</td>
            <td>{{ item.pe }}</td>
            <td>{{ item.pp }}</td>
            <td>{{ item.pnp }}</td>
            <td>{{ item.gf }}</td>
            <td>{{ item.gc }}</td>
            <td>{{ item.bonificacion }}</td>
            <td>{{ item.gd }}</td>
            <td>
              <feather-icon
                :id="`invoice-row-${item.id}-send-icon`"
                icon="EditIcon"
                class="cursor-pointer"
                size="16"
                @click="showModifyTabla(item)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import store from '@/store'
import { BModal } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import ModalUpdateTabla from './ModifyTabla.vue'
import {
  URL,
  // TARJETAS,
  // USER,
  // ROLES,
  // UBICACIONES,
  // xxxx,
  // xxxx,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    ModalUpdateTabla,
  },
  props: {
    listTablaPosiciones: Array,
  },
  setup(props, { emit }) {
    const equipoSeleccionado = ref(null)
    const listBonificaciones = ref([])
    const { getApi } = apiCall()

    async function showTablaBonificaciones() {
      // console.log(grupoClick)
      // console.log(equipoSeleccionado.value)
      const path = `ApiFixture/getBonificaciones/${equipoSeleccionado.value.id_equipo}/${equipoSeleccionado.value.etapa}/${equipoSeleccionado.value.grupo}/${equipoSeleccionado.value.id_campeonato}`
      const data = await getApi(URL, path)
      listBonificaciones.value = data.bonificaciones
      // console.log(listBonificaciones)
    }
    function showModifyTabla(item) {
      store.commit('someVariables/UPDATE_SHOW_MODIFY_TABLE', true)
      equipoSeleccionado.value = item
      showTablaBonificaciones()
      // console.log(item)
    }

    function updateTabla() {
      showTablaBonificaciones()
      emit('updateTabla')
    }
    return {
      showModifyTabla,
      equipoSeleccionado,
      updateTabla,
      listBonificaciones,
    }
  },
}
</script>
<style scoped>
.table th,
.table td {
  padding: 0.5rem;
}
</style>
